import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ProductService } from '../../services/index';
import { ProductShort } from '../../models/index';

import { LazyLoadEvent } from 'primeng/primeng';

@Component({
  selector: 'product-select-dialog',
  templateUrl: './product-select-dialog.component.html',
  styleUrls: ['./product-select-dialog.component.scss'],
  animations: []
})
export class ProductSelectDialogComponent {
    @Input()  private button: string = '';
    @Input()  private withSizes: boolean = false;
    @Input()  private closeOnSelect: boolean = true;
	@Input()  private disabled: boolean = false;
    @Input()  private contactId: number;
    @Output() private select: EventEmitter<ProductShort> = new EventEmitter();
    
    private isOpen: boolean = false;

	private products: ProductShort[] = [];
	private totalProducts: number = 0;
	private lastEvent: LazyLoadEvent;
    
    constructor(private productService: ProductService) { }

    private onSelect(event)
    {
        let product: ProductShort = event.data;
        console.log(product);
        
        this.select.emit(product);

        if (this.closeOnSelect) {
            this.close();
        }
    }

    open()
    {
        this.isOpen = true;
        this.loadProducts();
    }

    close()
    {
        this.isOpen = false;
    }
    
	loadProducts(event?: any) {
		if (!event) {
			event = this.lastEvent;
		}

		if (!event) {
			return;
		} else {
			this.lastEvent = event;
		}

		if (!this.isOpen) {
			return;
		}

        if (this.contactId) {
            event.contact_id = this.contactId;
        }

		this.productService.getLazyShort(event).subscribe(data => {
			this.products = data.data;
			this.totalProducts = data.total;
		}, err => {
		});
	}

}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/modules/product-select-dialog/product-select-dialog.component.ts